import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "image-outline" }

import { computed, PropType } from 'vue'
import { PPTImageElement } from '@/types/slides'
import useClipImage from '../useClipImage'

import ImageRectOutline from './ImageRectOutline.vue'
import ImageEllipseOutline from './ImageEllipseOutline.vue'
import ImagePolygonOutline from './ImagePolygonOutline.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  elementInfo: {
    type: Object as PropType<PPTImageElement>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const clip = computed(() => props.elementInfo.clip)
const { clipShape } = useClipImage(clip)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(clipShape).type === 'rect')
      ? (_openBlock(), _createBlock(ImageRectOutline, {
          key: 0,
          width: __props.elementInfo.width,
          height: __props.elementInfo.height,
          radius: _unref(clipShape).radius,
          outline: __props.elementInfo.outline
        }, null, 8, ["width", "height", "radius", "outline"]))
      : (_unref(clipShape).type === 'ellipse')
        ? (_openBlock(), _createBlock(ImageEllipseOutline, {
            key: 1,
            width: __props.elementInfo.width,
            height: __props.elementInfo.height,
            outline: __props.elementInfo.outline
          }, null, 8, ["width", "height", "outline"]))
        : (_unref(clipShape).type === 'polygon')
          ? (_openBlock(), _createBlock(ImagePolygonOutline, {
              key: 2,
              width: __props.elementInfo.width,
              height: __props.elementInfo.height,
              outline: __props.elementInfo.outline,
              createPath: _unref(clipShape).createPath
            }, null, 8, ["width", "height", "outline", "createPath"]))
          : _createCommentVNode("", true)
  ]))
}
}

})